import { gql } from '@apollo/client';


export const VIN_DECODE_RESULT = gql`
  query VIN_DECODE_RESULT($vin: String!, $originatorId: ID!){
    vinDecodeResult(vin: $vin, originatorId: $originatorId) {
     vehicleMakeId
     vehicleModelId
     vehicleMake {
      id
      name
      nhtsaId
     }
     vehicleModel {
      id
      name
      nhtsaId
     }
     year
    }
  }
`;


